import React from "react";
import html2canvas from "html2canvas";
import { RadialBarChart } from "../dashboard/dashboard";
import { useStores } from "../../store";
import topimage from "./top-removebg-preview.png";
import bottomimage from "./bottom-removebg-preview.png";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { saveAs } from "file-saver";
import { useRef } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { getLogoBySubdomain, getwebsiteUrl } from "../../services/white_label";
export default function Certificate() {
  const { CommonStore } = useStores();

  const [name, setName] = useState("");
  const [interviewTopic, setInterviewTopic] = useState("");
  const [date, setDate] = useState("");
  const [technicalSkills, setTechnicalSkills] = useState("");
  const [communicationSkills, setCommunicationSkills] = useState("");
  const [askUserToDownload, setAskUserToDownload] = useState(true);
  const [overallRating, setOverallRating] = useState("");
  const [downloaded, setDownloaded] = useState(false);
  const location = useLocation(); // Get the current URL location
  const query = queryString.parse(location.search);
  console.log(query);
  useEffect(() => {
    setName(query.name);
    setInterviewTopic(query.interviewTopic);
    const timestmap = parseInt(query.date);
    const date = new Date(timestmap);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    // console.log("month: ", month);
    console.log("interview Topic:", interviewTopic);

    const year = date.getFullYear();
    const dateString = `${day}/${month}/${year}`;
    setDate(dateString);
    setTechnicalSkills(query.technicalSkills);
    setCommunicationSkills(query.communicationSkills);
    setOverallRating(query.overallRating);
    downloadConfirmation();
    CommonStore.setAskUserToDownloadCertificate(false);
    // console.log("formated date: ", dateString);
  }, []);
  const confirmationShownRef = useRef(false);

  const downloadConfirmation = () => {
    if (!CommonStore.askUserToDownloadCertificate) return;
    setTimeout(() => {
      const userConfirmation = window.confirm(
        "Would you like to download the interview Report?"
      );
      if (userConfirmation) {
        handleGenerateAndDownload();
      }
      CommonStore.setAskUserToDownloadCertificate(false);
    }, 2000);
  };

  const componentRef = useRef();
  const handleGenerateAndDownload = () => {
    html2canvas(componentRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, "certificate.jpg");
      });
    });
  };

  return (
    <div
      ref={componentRef}
      id="yourDivId"
      className="md:flex lg:flex hidden justify-center items-center w-full  absolute h-screen bg-[#525659]"
    >
      <Helmet>
        <meta name="viewport" content="width=1920,  initial-scale=1.0 " />
      </Helmet>
      <div className="w-[80vw]  bg-white flex flex-col items-center relative rounded-[20px] overflow-hidden">
        <img
          src={topimage}
          className="absolute h-[85%] top-[-250px] left-[-600px]"
          alt=""
        />
        <img
          src={bottomimage}
          className="absolute bottom-[-250px] right-[-600px] h-[85%] "
          alt=""
        />
        {/* <img src={badge} className="absolute h-20 bottom-20 left-20" alt="" /> */}
        <div>
          <img src={getLogoBySubdomain(true)} className="w-48 mt-12" />
        </div>
        <div className="flex justify-around w-[85%] mt-10 -ml-20">
          <div className="border-r border-[#D3AC39] p-14 ">
            <h2 className="text-[#D3AC39] text-4xl ml-[-50px] font-thin amsterdam">
              Report <br />
            </h2>
            <h2 className="text-[#D3AC39] text-3xl font-light text-end mt-5">
              on Mock interview
            </h2>
          </div>
          <div className="flex flex-col justify-center pl-5 ml-[-400px]">
            <h2 className="text-[#D3AC39] text-2xl font-light mb-5 pl-14">
              Report given to interview <br />
            </h2>
            <h2 className="text-[#D3AC39]  mt-5 text-3xl font-thin amsterdam pb-1 pt-4 text-center">
              {name}{" "}
            </h2>
          </div>
        </div>
        <h1 className="mt-5 text-center text-[#263574]  font-normal opacity-70">
          This is awarded to for attempting the{" "}
        </h1>{" "}
        <span className="font-medium text-4xl opacity-100 text-center text-[#263574]  ">
          {" "}
          {interviewTopic.charAt(0).toUpperCase() +
            interviewTopic.slice(1)}{" "}
          Interview{" "}
        </span>{" "}
        <h1 className="text-center text-[#263574]  font-normal opacity-70">
          {" "}
          on
        </h1>
        <p className="mt-3 bg-[#D3AC39] text-white py-1 px-3 pb-1">{date}</p>
        <div className="flex justify-between w-[50%]">
          <RadialBarChart
            score={technicalSkills ?? 40}
            label={"Technical skills"}
            color={"#F6D36B"}
          />
          <RadialBarChart
            score={communicationSkills ?? 72}
            label={"Communication skills"}
            color={"#F6D36B"}
          />
          <RadialBarChart
            score={overallRating ?? 50}
            label={"Overall Score"}
            color={"#F6D36B"}
          />
        </div>
        <p className="mt-3 tracking-[5px] font-bold text-gray-800 pb-3">
          {getwebsiteUrl()}
        </p>
      </div>
    </div>
  );
}
